module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DModal', {
    attrs: {
      "show-close": false,
      "isBgOverlay": true
    }
  }, [_c('div', {
    staticClass: "d-modal text-dark d-modal__select-teacher-for-sub",
    staticStyle: {
      "width": "400px"
    },
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "d-modal__content"
  }, [_c('h3', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['which_teacher_will']) + " " + _vm._s(_vm.substitute.name) + " " + _vm._s(_vm.i18n[_vm.locale]['be_substitute_for']) + "?")]), _vm._v(" "), _c('ul', _vm._l((_vm.teachers), function(teacher) {
    return _c('li', {
      key: teacher.id,
      staticClass: "select-teacher-for-sub__teacher"
    }, [_vm._v("\n          " + _vm._s(teacher.name) + "\n          "), _c('button', {
      staticClass: "bttn bttn-primary",
      staticStyle: {
        "padding": "2px 1rem"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.$emit('select', teacher)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('vue2.common.select')))])])
  }), 0)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-444c29a8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DCalendar/DCalendarShowEventSubFor.vue
// module id = 1612
// module chunks = 1